import { useContext } from "react";

import { EventsStateContext } from "../../../../../context/EventsProvider";
import Svg, { SvgEnum } from "../../../../ui library/components/svgs/standard/svg";

import RenderSubMenu from "./renderSubMenu";

export default function RenderActionButtons() {
  const actionButtonList = [];
  const globalEventDispatch = useContext(EventsStateContext);
  actionButtonList.push({
    link: "/notifications",
    content: globalEventDispatch.notifications.count,
    icon: <Svg name={SvgEnum.HisNotification} />,
  });

  actionButtonList.push({
    icon: <Svg name={SvgEnum.HisAvatar} sx={{ height: "24px", width: "24px" }} />,
    subMenuList: RenderSubMenu,
  });

  return actionButtonList;
}
